/**
 * Admin Theme Toggle
 *
 * Allows admin to switch the public marketing site between dark and light mode.
 * Only visible in the sales portal sidebar.
 */

import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export function ThemeToggle() {
  const { theme, setTheme, isLoading } = useTheme();

  if (isLoading) return null;

  return (
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="flex items-center gap-3 w-full px-4 py-3 text-sm font-semibold rounded-md transition-all text-gray-300 hover:text-white hover:bg-white/10 border border-white/[0.08] hover:border-lime-500/30"
      title={`Marketing site: ${theme} mode — click to switch`}
    >
      {theme === "dark" ? (
        <>
          <Moon className="h-4 w-4 text-lime-400" />
          <span>Site Theme: Dark</span>
        </>
      ) : (
        <>
          <Sun className="h-4 w-4 text-amber-400" />
          <span>Site Theme: Light</span>
        </>
      )}
    </button>
  );
}
